const EAN_PAYMENT_METHOD = 'custom_ean_payment';
const CART_STEP_LINK = '.swoo-checkout-steps__step--cart a';
const FLOATING_CART_TOGGLE = '#swoo-floating-ajax-cart-popup-pro-toggle';

export default class CheckoutEventHandler {
    /**
     * @returns this
     */
    static make() {
        return new this;
    }
    /**
     * The shop has an AJAX cart, so the cart step opens it instead of leaving the checkout.
     * The link is followed as usual when the floating cart is not on the page.
     *
     * @returns this
     */
    openFloatingCartFromCartStep() {
        jQuery(document.body).on('click', CART_STEP_LINK, function(event) {
            const $toggle = jQuery(FLOATING_CART_TOGGLE);
            if (!$toggle.length) {
                return;
            }
            event.preventDefault();
            $toggle.trigger('click');
        });
        return this;
    }
    /**
     * The server decides from the e-mail whether the free print is offered, so the order review is fetched again.
     *
     * @returns this
     */
    refreshFreePrintOfferWhenEmailIsChanged() {
        jQuery(document.body).on('change', 'form.checkout input#billing_email', function() {
            jQuery(document.body).trigger('update_checkout');
        });
        return this;
    }
    /**
     * @returns this
     */
    markAsBusinessWhenPayingWithEan() {
        const that = this;
        this.$form = jQuery('form.checkout');
        this.$businessCheckbox = this.$form.find('#show_billing_company');
        this.$companyName = this.$form.find('#billing_company');
        if (!this.$businessCheckbox.length || !this.$companyName.length) {
            return this;
        }
        this.eanIsSelected = false;
        this.markedByEan = false;
        this.isMarking = false;
        this.companyNameBeforeUnmarking = '';

        this.$businessCheckbox.on('change', function() {
            if (that.isMarking) {
                return;
            }
            // The customer has made the choice, so it is no longer changed together with the payment method.
            that.markedByEan = false;
            that.companyNameBeforeUnmarking = '';
        });
        // Deferred until the other handlers of the event, including the ones showing the company name, have run.
        jQuery(document.body).on('payment_method_selected updated_checkout', function() {
            window.setTimeout(() => that.doMarkAsBusinessWhenPayingWithEan(), 0);
        });
        jQuery(function() {
            window.setTimeout(() => that.doMarkAsBusinessWhenPayingWithEan(), 0);
        });
        return this;
    }

    doMarkAsBusinessWhenPayingWithEan() {
        const eanIsSelected = this.$form
            .find('input[name="payment_method"][value="' + EAN_PAYMENT_METHOD + '"]')
            .is(':checked');
        if (eanIsSelected === this.eanIsSelected) {
            return;
        }
        this.eanIsSelected = eanIsSelected;

        if (eanIsSelected) {
            this.markAsBusiness();
            return;
        }
        this.unmarkAsBusiness();
    }

    markAsBusiness() {
        if (this.$businessCheckbox.is(':checked')) {
            return;
        }
        this.setBusinessCheckbox(true);
        this.markedByEan = true;

        if (this.companyNameBeforeUnmarking !== '' && this.$companyName.val() === '') {
            this.$companyName.val(this.companyNameBeforeUnmarking).trigger('input');
        }
    }

    unmarkAsBusiness() {
        if (!this.markedByEan) {
            return;
        }
        this.markedByEan = false;
        if (!this.$businessCheckbox.is(':checked')) {
            return;
        }
        this.companyNameBeforeUnmarking = this.$companyName.val();
        this.setBusinessCheckbox(false);
    }

    /**
     * @param {boolean} checked
     */
    setBusinessCheckbox(checked) {
        this.isMarking = true;
        this.$businessCheckbox.prop('checked', checked);
        // A native event, as the company name is shown and hidden by a native listener.
        this.$businessCheckbox[0].dispatchEvent(new Event('change', { bubbles: true }));
        this.isMarking = false;
    }
}
